"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _Options = _interopRequireDefault(require("../../Options"));

var _FormikValidation = _interopRequireDefault(require("../FormikValidation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject(), _spacing.default.s1);

Container.displayName = 'Container';

var FormikOptions = function FormikOptions(_ref) {
  var onChange = _ref.onChange,
      selectedValue = _ref.selectedValue,
      name = _ref.name,
      options = _ref.options,
      rest = _objectWithoutPropertiesLoose(_ref, ["onChange", "selectedValue", "name", "options"]);

  return _react.default.createElement(Container, null, _react.default.createElement(_Options.default, _extends({}, rest, {
    onChange: onChange,
    selectedValue: selectedValue,
    options: options
  })), _react.default.createElement(_FormikValidation.default, {
    name: name
  }));
};

FormikOptions.propTypes = {
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  selectedValue: _propTypes.string,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired,
    e2e: _propTypes.string
  })).isRequired
};
FormikOptions.defaultProps = {
  selectedValue: ''
};
var _default = FormikOptions;
exports.default = _default;